module.exports = __webpack_public_path__ + "static/media/service.1a8da8b0.svg";